import { toast } from 'react-toastify'

export const TOAST_ERROR = (text) =>
    toast(text, {
        theme: 'light',
        autoClose: false,
        position: 'top-center',
        delay: 0,
        type: 'error',
        toastId: 'error',
        pauseOnHover: true,
    })
export const TOAST_SUCCESS = (text) =>
    toast(text, {
        theme: 'light',
        autoClose: false,
        position: 'top-center',
        type: 'success',
        toastId: 'success',
        pauseOnHover: true,
    })
export const TOAST_WARNING = (text) =>
    toast(text, {
        theme: 'light',
        position: 'top-center',
        autoClose: false,
        type: 'warning',
        toastId: 'warning',
        pauseOnHover: false,
    })

export const TOAST_COSMETOLOG = (text) =>
    toast(text, {
        theme: 'light',
        autoClose: false,
        position: 'top-center',
        type: 'success',
        toastId: 'success',
        pauseOnHover: true,
    })
